import { Button } from "@draftkings/arena-web";
import * as React from "react";
export const CashOutViewRegular = React.memo(function CashOutViewRegular(props) {
    const { formattedCashOutAmount, purchaseId, onClick } = props;
    return React.createElement(Button, { onClick: onClick, widthMode: "stretch", variant: "cashOutButton", testId: `cashout-button-${purchaseId}` }, formattedCashOutAmount);
});
//# sourceMappingURL=CashOutViewRegular.js.map